import React from 'react';

import { RailStoreV2 } from '@kaltura-ott/tvpil-shared';

import { DEFAULT_HEIGHT } from 'consts';
import { useRailSkeletonSizer } from 'hooks';

import { useRailContext } from '../../../SearchGridProvider';
import { AssetCardProvider } from '../RailCard/AssetCardProvider/AssetCardProvider';
import AssetCardResolveRendering from '../RailCard/AssetCardResolveRendering/AssetCardResolveRendering';
import { RailSkeletonAsset } from '../RailSkeleton/RailSkeleton';

/**
 * @deprecated Will be removed after rhino migration.
*/

const RailGridResolveRendering = ({ data, index }: { data: any; index: number }) => {
  const { store } = useRailContext();
  const { columnWidth } = useRailSkeletonSizer(store);
  const { lastPageWasLoaded } = (store as RailStoreV2 | any) || {};
  if (!data.data) {
    // hide skeleton items if all grid items were loaded
    if (lastPageWasLoaded) {
      return null;
    }
    return <RailSkeletonAsset height={store.railHeight || DEFAULT_HEIGHT} width={columnWidth} />;
  }

  if (store.isRailEmpty) {
    return null;
  }

  return (
    <AssetCardProvider asset={data} listIndex={index}>
      <AssetCardResolveRendering />
    </AssetCardProvider>
  );
};

export default React.memo(RailGridResolveRendering);
